import { LILAC_200, tokens, WHITE } from '@airtel/air-design-system';
import { Dimensions, StyleSheet } from 'react-native';
export var getInputWidgetStyles = props => {
  var showDivider = props.showDivider,
    _props$autoCompleteHe = props.autoCompleteHeightRatio,
    autoCompleteHeightRatio = _props$autoCompleteHe === void 0 ? 0.5 : _props$autoCompleteHe;
  return StyleSheet.create({
    container: {
      position: 'relative',
      zIndex: 100
    },
    autoCompleteContentContainer: {
      paddingVertical: tokens.spacing.SPACING_16,
      backgroundColor: LILAC_200,
      borderWidth: tokens.spacing.SPACING_1,
      borderColor: WHITE,
      borderBottomLeftRadius: tokens.borderRadius.BORDER_RADIUS_16,
      borderBottomRightRadius: tokens.borderRadius.BORDER_RADIUS_16,
      maxHeight: Dimensions.get('screen').height * autoCompleteHeightRatio,
      position: 'absolute',
      top: '100%',
      right: 0,
      left: 0
    },
    listItemContainer: {
      display: 'flex',
      paddingHorizontal: tokens.spacing.SPACING_20
    },
    listItemTitle: {
      marginBottom: tokens.spacing.SPACING_4
    },
    divider: {
      marginVertical: tokens.spacing.SPACING_8
    },
    inputDivider: {
      marginTop: tokens.spacing.SPACING_20
    },
    input: Object.assign({}, showDivider && {
      marginBottom: 0
    })
  });
};